<template>
    <div class="bee-page-container">
      <div class="bee-row bee-row-1">
        <div class="bee-row-content">
          <div class="bee-col bee-col-1 bee-col-w12">
            <div class="bee-block bee-block-1 bee-image">
              <a href="https://www.wegow.com/es-es/"> <img alt="Wegow" class="bee-center bee-fixedwidth" src="images/LOGORecurso_3.png" style="max-width: 600px;" /></a>
            </div>
            <div class="bee-block bee-block-2 bee-heading">
              <h1
                style="
                  color: #ffffff;
                  direction: ltr;
                  font-family: Arial, 'Helvetica Neue', Helvetica, sans-serif;
                  font-size: 18px;
                  font-weight: 400;
                  letter-spacing: normal;
                  line-height: 120%;
                  text-align: center;
                  margin-top: 0;
                  margin-bottom: 0;
                "
              >
                <span class="tinyMce-placeholder">
                  ¿No puedes ir al concierto o festival?
                  <br />
                  ¡Vende tu entrada con WeSwap!
                </span>
              </h1>
            </div>
            <div class="bee-block bee-block-3 bee-image">
              <img alt="" class="bee-center bee-fixedwidth bee-fullwidthOnMobile" src="images/weswap-02_2.png" style="max-width: 400px;" />
            </div>
            <div class="bee-block bee-block-4 bee-heading">
              <h1
                style="
                  color: #ffffff;
                  direction: ltr;
                  font-family: Arial, 'Helvetica Neue', Helvetica, sans-serif;
                  font-size: 18px;
                  font-weight: 400;
                  letter-spacing: normal;
                  line-height: 120%;
                  text-align: center;
                  margin-top: 0;
                  margin-bottom: 0;
                "
              >
                <span class="tinyMce-placeholder">
                  ¿Te quedaste sin entrada?
                  <br />
                  ¡Mira si hay alguna disponible de otro fan!
                </span>
              </h1>
            </div>
            <div class="bee-block bee-block-5 bee-heading">
              <h1
                style="
                  color: #ffffff;
                  direction: ltr;
                  font-family: Arial, 'Helvetica Neue', Helvetica, sans-serif;
                  font-size: 30px;
                  font-weight: 700;
                  letter-spacing: normal;
                  line-height: 120%;
                  text-align: center;
                  margin-top: 0;
                  margin-bottom: 0;
                "
              >
                <strong>
                  100% transparente,
                  <br />
                  ético y seguro
                </strong>
              </h1>
            </div>
            <div class="bee-block bee-block-6 bee-heading">
              <h1
                style="
                  color: #ffffff;
                  direction: ltr;
                  font-family: Arial, 'Helvetica Neue', Helvetica, sans-serif;
                  font-size: 18px;
                  font-weight: 700;
                  letter-spacing: normal;
                  line-height: 120%;
                  text-align: center;
                  margin-top: 0;
                  margin-bottom: 0;
                "
              >
                <strong>
                  WeSwap es un nuevo servicio de Wegow para el intercambio de entradas entre usuarios reales, al mismo precio y sin especulación.
                </strong>
              </h1>
            </div>
            <div class="bee-block bee-block-7 bee-heading">
              <h1
                style="
                  color: #ffffff;
                  direction: ltr;
                  font-family: Arial, 'Helvetica Neue', Helvetica, sans-serif;
                  font-size: 12px;
                  font-weight: 400;
                  letter-spacing: normal;
                  line-height: 120%;
                  text-align: center;
                  margin-top: 0;
                  margin-bottom: 0;
                "
              >
                <span class="tinyMce-placeholder">
                  Si has comprado tu entrada en Wegow, y finalmente no puedes acudir al concierto o festival, con WeSwap puedes ponerla a la venta de forma cómoda y rápida, siempre y cuando el evento esté
                  <em>
                    sold out
                  </em>
                  . Por otro lado, si te has quedado sin entrada, ahora tendrás la oportunidad de adquirirla al precio original, y de manera 100% segura en el entorno Wegow.
                </span>
              </h1>
            </div>
            <div class="bee-block bee-block-8 bee-heading">
              <h1
                style="
                  color: #2effec;
                  direction: ltr;
                  font-family: Arial, 'Helvetica Neue', Helvetica, sans-serif;
                  font-size: 18px;
                  font-weight: 700;
                  letter-spacing: normal;
                  line-height: 120%;
                  text-align: center;
                  margin-top: 0;
                  margin-bottom: 0;
                "
              >
                <span class="tinyMce-placeholder">
                  ¿Cómo funciona WeSwap?
                </span>
              </h1>
            </div>
            <div class="div-video">
              <iframe class="iframe-video" type="text/html" src="https://www.youtube.com/embed/xYRz5r13XxI" data-v-b704b49a="">
                </iframe>
          </div>
          </div>
        </div>
      </div>
      <div class="bee-row bee-row-2">
        <div class="bee-row-content">
          <div class="bee-col bee-col-1 bee-col-w12">
            <div class="bee-block bee-block-1 bee-heading">
              <h1
                class="normal"
                style="
                  color: #252525;
                  direction: ltr;
                  font-family: 'Roboto', Tahoma, Verdana, Segoe, sans-serif;
                  font-size: 15px;
                  font-weight: 700;
                  letter-spacing: normal;
                  line-height: 120%;
                  text-align: center;
                  margin-top: 0;
                  margin-bottom: 0;
                "
              >
                <span class="tinyMce-placeholder">
                  Quiero vender mi entrada
                </span>
              </h1>
            </div>
          </div>
        </div>
      </div>
      <div class="bee-row bee-row-3">
        <div class="bee-row-content">
          <div class="bee-col bee-col-1 bee-col-w12">
            <div class="bee-block bee-block-1 bee-heading">
              <h1
                class="normal"
                style="
                  color: #2effec;
                  direction: ltr;
                  font-family: 'Roboto', Tahoma, Verdana, Segoe, sans-serif;
                  font-size: 15px;
                  font-weight: 400;
                  letter-spacing: normal;
                  line-height: 120%;
                  text-align: left;
                  margin-top: 0;
                  margin-bottom: 0;
                "
              >
                <strong>
                  ¿Qué entradas puedo vender con WeSwap?
                </strong>
              </h1>
            </div>
            <div class="bee-block bee-block-2 bee-heading">
              <h1
                class="small"
                style="
                  color: #ffffff;
                  direction: ltr;
                  font-family: 'Roboto', Tahoma, Verdana, Segoe, sans-serif;
                  font-size: 11px;
                  font-weight: 400;
                  letter-spacing: normal;
                  line-height: 120%;
                  text-align: left;
                  margin-top: 0;
                  margin-bottom: 0;
                "
              >
                <span class="tinyMce-placeholder">
                  Podrás vender tus entradas para aquellos eventos en los que:
                </span>
              </h1>
            </div>
            <div class="bee-block bee-block-3 bee-list">
              <ol start="1">
                <li aria-level="1">
                  La venta de entradas esté directamente gestionada por Wegow.
                </li>
                <li aria-level="1">
                  El evento esté
                  <em>
                    sold out
                  </em>
                  (todas las entradas agotadas).
                </li>
              </ol>
            </div>
            <div class="bee-block bee-block-4 bee-divider">
              <div class="center" style="border-top: 1px solid #535353; width: 100%;"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="bee-row bee-row-4">
        <div class="bee-row-content">
          <div class="bee-col bee-col-1 bee-col-w12">
            <div class="bee-block bee-block-1 bee-heading">
              <h1
                class="normal"
                style="
                  color: #2effec;
                  direction: ltr;
                  font-family: 'Roboto', Tahoma, Verdana, Segoe, sans-serif;
                  font-size: 15px;
                  font-weight: 400;
                  letter-spacing: normal;
                  line-height: 120%;
                  text-align: left;
                  margin-top: 0;
                  margin-bottom: 0;
                "
              >
                <strong>
                  ¿Cómo pongo mis entradas a la venta?
                </strong>
              </h1>
            </div>
            <div class="bee-block bee-block-2 bee-heading">
              <h1
                class="small"
                style="
                  color: #ffffff;
                  direction: ltr;
                  font-family: 'Roboto', Tahoma, Verdana, Segoe, sans-serif;
                  font-size: 11px;
                  font-weight: 400;
                  letter-spacing: normal;
                  line-height: 120%;
                  text-align: left;
                  margin-top: 0;
                  margin-bottom: 0;
                "
              >
                <span class="tinyMce-placeholder">
                  En tu app de Wegow o en wegow.com, accede a tu cuenta de usuario y, abre el apartado “Mis entradas”. Si el evento y tus tickets cumplen los requisitos, aparecerá un botón de “Vender”. Al pulsarlo, tras aceptar las
                  condiciones, tus entradas estarán disponibles para que las compre otro usuario.
                </span>
              </h1>
            </div>
            <div class="bee-block bee-block-3 bee-divider">
              <div class="center" style="border-top: 1px solid #535353; width: 100%;"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="bee-row bee-row-5">
        <div class="bee-row-content">
          <div class="bee-col bee-col-1 bee-col-w12">
            <div class="bee-block bee-block-1 bee-heading">
              <h1
                class="normal"
                style="
                  color: #2effec;
                  direction: ltr;
                  font-family: 'Roboto', Tahoma, Verdana, Segoe, sans-serif;
                  font-size: 15px;
                  font-weight: 400;
                  letter-spacing: normal;
                  line-height: 120%;
                  text-align: left;
                  margin-top: 0;
                  margin-bottom: 0;
                "
              >
                <strong>
                  ¿Y si me arrepiento y quiero quitarlas de la venta?
                </strong>
              </h1>
            </div>
            <div class="bee-block bee-block-2 bee-heading">
              <h1
                class="small"
                style="
                  color: #ffffff;
                  direction: ltr;
                  font-family: 'Roboto', Tahoma, Verdana, Segoe, sans-serif;
                  font-size: 11px;
                  font-weight: 400;
                  letter-spacing: normal;
                  line-height: 120%;
                  text-align: left;
                  margin-top: 0;
                  margin-bottom: 0;
                "
              >
                Si tus entradas aún no se han vendido y quieres utilizarlas tú, en “Mis Entradas” pulsa sobre “Quitar de la venta” para que sigan siendo tuyas.
              </h1>
            </div>
            <div class="bee-block bee-block-3 bee-divider">
              <div class="center" style="border-top: 1px solid #535353; width: 100%;"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="bee-row bee-row-6">
        <div class="bee-row-content">
          <div class="bee-col bee-col-1 bee-col-w12">
            <div class="bee-block bee-block-1 bee-heading">
              <h1
                class="normal"
                style="
                  color: #2effec;
                  direction: ltr;
                  font-family: 'Roboto', Tahoma, Verdana, Segoe, sans-serif;
                  font-size: 15px;
                  font-weight: 400;
                  letter-spacing: normal;
                  line-height: 120%;
                  text-align: left;
                  margin-top: 0;
                  margin-bottom: 0;
                "
              >
                <strong>
                  ¿Por cuánto dinero puedo vender las entradas que no voy a utilizar?
                </strong>
              </h1>
            </div>
            <div class="bee-block bee-block-2 bee-heading">
              <h1
                class="small"
                style="
                  color: #ffffff;
                  direction: ltr;
                  font-family: 'Roboto', Tahoma, Verdana, Segoe, sans-serif;
                  font-size: 11px;
                  font-weight: 400;
                  letter-spacing: normal;
                  line-height: 120%;
                  text-align: left;
                  margin-top: 0;
                  margin-bottom: 0;
                "
              >
                Venderás tus entradas por el mismo precio que pagaste por ellas. No podrás añadirles un beneficio para ti ni especular con ellas. En caso de venderse, recibirás el mismo importe que pagaste exceptuando los gastos de gestión.
              </h1>
            </div>
            <div class="bee-block bee-block-3 bee-divider">
              <div class="center" style="border-top: 1px solid #535353; width: 100%;"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="bee-row bee-row-7">
        <div class="bee-row-content">
          <div class="bee-col bee-col-1 bee-col-w12">
            <div class="bee-block bee-block-1 bee-heading">
              <h1
                class="normal"
                style="
                  color: #2effec;
                  direction: ltr;
                  font-family: 'Roboto', Tahoma, Verdana, Segoe, sans-serif;
                  font-size: 15px;
                  font-weight: 400;
                  letter-spacing: normal;
                  line-height: 120%;
                  text-align: left;
                  margin-top: 0;
                  margin-bottom: 0;
                "
              >
                <strong>
                  ¿Cómo recibiré el dinero?
                </strong>
              </h1>
            </div>
            <div class="bee-block bee-block-2 bee-heading">
              <h1
                class="small"
                style="
                  color: #ffffff;
                  direction: ltr;
                  font-family: 'Roboto', Tahoma, Verdana, Segoe, sans-serif;
                  font-size: 11px;
                  font-weight: 400;
                  letter-spacing: normal;
                  line-height: 120%;
                  text-align: left;
                  margin-top: 0;
                  margin-bottom: 0;
                "
              >
                Si tu entrada se vende, recibirás el dinero como una devolución en la misma tarjeta que utilizaste para hacer la compra, en un plazo máximo de 30 días.
              </h1>
            </div>
            <div class="bee-block bee-block-3 bee-divider">
              <div class="center" style="border-top: 1px solid #535353; width: 100%;"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="bee-row bee-row-8">
        <div class="bee-row-content">
          <div class="bee-col bee-col-1 bee-col-w12">
            <div class="bee-block bee-block-1 bee-heading">
              <h1
                class="normal"
                style="
                  color: #2effec;
                  direction: ltr;
                  font-family: 'Roboto', Tahoma, Verdana, Segoe, sans-serif;
                  font-size: 15px;
                  font-weight: 400;
                  letter-spacing: normal;
                  line-height: 120%;
                  text-align: left;
                  margin-top: 0;
                  margin-bottom: 0;
                "
              >
                <strong>
                  ¿Y si no se venden?
                </strong>
              </h1>
            </div>
            <div class="bee-block bee-block-2 bee-heading">
              <h1
                class="small"
                style="
                  color: #ffffff;
                  direction: ltr;
                  font-family: 'Roboto', Tahoma, Verdana, Segoe, sans-serif;
                  font-size: 11px;
                  font-weight: 400;
                  letter-spacing: normal;
                  line-height: 120%;
                  text-align: left;
                  margin-top: 0;
                  margin-bottom: 0;
                "
              >
                Si en el momento del cierre de la venta de entradas, la tuya no ha sido comprada por nadie, podrás utilizarla tú.
              </h1>
            </div>
          </div>
        </div>
      </div>
      <div class="bee-row bee-row-9">
        <div class="bee-row-content">
          <div class="bee-col bee-col-1 bee-col-w12">
            <div class="bee-block bee-block-1 bee-heading">
              <h1
                class="normal"
                style="
                  color: #252525;
                  direction: ltr;
                  font-family: 'Roboto', Tahoma, Verdana, Segoe, sans-serif;
                  font-size: 15px;
                  font-weight: 700;
                  letter-spacing: normal;
                  line-height: 120%;
                  text-align: center;
                  margin-top: 0;
                  margin-bottom: 0;
                "
              >
                <span class="tinyMce-placeholder">
                  Quiero comprar una entrada WeSwap
                </span>
              </h1>
            </div>
          </div>
        </div>
      </div>
      <div class="bee-row bee-row-10">
        <div class="bee-row-content">
          <div class="bee-col bee-col-1 bee-col-w12">
            <div class="bee-block bee-block-1 bee-heading">
              <h1
                class="normal"
                style="
                  color: #2effec;
                  direction: ltr;
                  font-family: 'Roboto', Tahoma, Verdana, Segoe, sans-serif;
                  font-size: 15px;
                  font-weight: 400;
                  letter-spacing: normal;
                  line-height: 120%;
                  text-align: left;
                  margin-top: 0;
                  margin-bottom: 0;
                "
              >
                <strong>
                  ¿Dónde compro una entrada WeSwap?
                </strong>
              </h1>
            </div>
            <div class="bee-block bee-block-2 bee-heading">
              <h1
                class="small"
                style="
                  color: #ffffff;
                  direction: ltr;
                  font-family: 'Roboto', Tahoma, Verdana, Segoe, sans-serif;
                  font-size: 11px;
                  font-weight: 400;
                  letter-spacing: normal;
                  line-height: 120%;
                  text-align: left;
                  margin-top: 0;
                  margin-bottom: 0;
                "
              >
                <span class="tinyMce-placeholder">
                  ¡Fácil! Las entradas de otros usuarios que no puedan asistir, y que las hayan puesto a la venta a través de WeSwap, aparecerán en el mismo evento en el que se vendían antes de que se agotasen. Búscalo en tu app Wegow o en
                  wegow.com y, si no hay ninguna disponible, ¡vuelve más adelante! Un usuario puede poner a la venta esa entrada que tanto deseas en cualquier momento!
                </span>
              </h1>
            </div>
            <div class="bee-block bee-block-3 bee-divider">
              <div class="center" style="border-top: 1px solid #535353; width: 100%;"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="bee-row bee-row-11">
        <div class="bee-row-content">
          <div class="bee-col bee-col-1 bee-col-w12">
            <div class="bee-block bee-block-1 bee-heading">
              <h1
                class="normal"
                style="
                  color: #2effec;
                  direction: ltr;
                  font-family: 'Roboto', Tahoma, Verdana, Segoe, sans-serif;
                  font-size: 15px;
                  font-weight: 400;
                  letter-spacing: normal;
                  line-height: 120%;
                  text-align: left;
                  margin-top: 0;
                  margin-bottom: 0;
                "
              >
                <strong>
                  ¿Pagaré por ella mucho más?
                </strong>
              </h1>
            </div>
            <div class="bee-block bee-block-2 bee-heading">
              <h1
                class="small"
                style="
                  color: #ffffff;
                  direction: ltr;
                  font-family: 'Roboto', Tahoma, Verdana, Segoe, sans-serif;
                  font-size: 11px;
                  font-weight: 400;
                  letter-spacing: normal;
                  line-height: 120%;
                  text-align: left;
                  margin-top: 0;
                  margin-bottom: 0;
                "
              >
                ¡No! Pagarás por tu entrada exactamente lo mismo que valía en un primer momento. El comprador no ganará un dinero adicional con esta venta, y tú no tienes que pagar más.
              </h1>
            </div>
            <div class="bee-block bee-block-3 bee-divider">
              <div class="center" style="border-top: 1px solid #535353; width: 100%;"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="bee-row bee-row-12">
        <div class="bee-row-content">
          <div class="bee-col bee-col-1 bee-col-w12">
            <div class="bee-block bee-block-1 bee-heading">
              <h1
                class="normal"
                style="
                  color: #2effec;
                  direction: ltr;
                  font-family: 'Roboto', Tahoma, Verdana, Segoe, sans-serif;
                  font-size: 15px;
                  font-weight: 400;
                  letter-spacing: normal;
                  line-height: 120%;
                  text-align: left;
                  margin-top: 0;
                  margin-bottom: 0;
                "
              >
                <strong>
                  ¿Es seguro comprar una entrada WeSwap?
                </strong>
              </h1>
            </div>
            <div class="bee-block bee-block-2 bee-heading">
              <h1
                class="small"
                style="
                  color: #ffffff;
                  direction: ltr;
                  font-family: 'Roboto', Tahoma, Verdana, Segoe, sans-serif;
                  font-size: 11px;
                  font-weight: 400;
                  letter-spacing: normal;
                  line-height: 120%;
                  text-align: left;
                  margin-top: 0;
                  margin-bottom: 0;
                "
              >
                Completamente seguro: tu entrada no podrá estar duplicada. Cuando compras una entrada a otro usuario, la suya deja de tener validez y solo podrás acceder tú con la que has comprado. Tu código para la verificación electrónica
                en el acceso al recinto será único, nadie excepto tú podrá utilizar esa entrada. Compra tu entrada y disfrútala con total tranquilidad.
              </h1>
            </div>
          </div>
        </div>
      </div>
      <div class="bee-row bee-row-13">
        <div class="bee-row-content">
          <div class="bee-col bee-col-1 bee-col-w12">
            <div class="bee-block bee-block-1 bee-heading">
              <h1
                style="
                  color: #ffffff;
                  direction: ltr;
                  font-family: Arial, 'Helvetica Neue', Helvetica, sans-serif;
                  font-size: 18px;
                  font-weight: 700;
                  letter-spacing: normal;
                  line-height: 120%;
                  text-align: center;
                  margin-top: 0;
                  margin-bottom: 0;
                "
              >
                <a href="https://www.wegow.com" rel="noopener" style="text-decoration: underline; color: #ffffff;" target="_blank">
                  <u>
                    <strong>
                      Volver a Wegow
                    </strong>
                  </u>
                </a>
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>

</template>

<script>
import TopHeader from '@/components/top-header/TopHeader.vue'
import SignupPurchase from '@/components/signup-purchase/SignupPurchase.vue'
import UserProfileOnboarding from '@/components/user-profile-onboarding/UserProfileOnboarding.vue'
import ModalError from '@/components/modal-error/ModalError.vue'
import Cookies from '@/components/cookies/Cookies.vue'
import BottomFooter from '@/components/bottom-footer/BottomFooter.vue'
import { initializeApp } from "firebase/app";
import { getFirestore, collection, addDoc } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

export default {
  components: {
    TopHeader,
    SignupPurchase,
    UserProfileOnboarding,
    ModalError,
    Cookies,
    BottomFooter
  },
  async created() {
    this.gtag('event', 'view-page', {'event_category': 'WeSwap', 'event_label': 'WeSwap Page'});
  },
  methods: {
    gtag(){
      dataLayer.push(arguments);
    },
  }
}
</script>

<style src='slick-carousel/slick/slick.css'></style>

<style src='slick-carousel/slick/slick-theme.css'></style>
<style>
</style>
